<template>
  <v-app>
    <component :is="showLayout ? 'HeaderAdm' : 'app-header'" />
    <v-main>
      <SnackbarGlobal />
      <CustomLoading v-model="isLoading" />
      <router-view />
      <v-btn v-if="!showLayout" class="whatsapp-float mini-float" color="green" dark fab small :href="WhatsApp"
        target="_blank">
        <v-icon small>mdi-whatsapp</v-icon>
      </v-btn>

      <v-btn v-if="!showLayout" class="call-float mini-float" color="blue darken-3" dark fab small
        :href="`tel:${phoneNumber}`">
        <v-icon small>mdi-phone</v-icon>
      </v-btn>

      <v-btn v-if="!showLayout" v-show="showScroll" fab dark small color="blue darken-3"
        class="scroll-to-top mini-float" @click="scrollToTop">
        <v-icon small>mdi-arrow-up</v-icon>
      </v-btn>
    </v-main>
    <!-- <FooterAdm v-if="showLayout" /> -->
  <component :is="showLayout ? '' : 'Footer'" />
  </v-app>
</template>
<script>
import CustomLoading from '@/components/CustomLoading.vue'
import SnackbarGlobal from '@/components/SnackbarGlobal.vue'
import HeaderAdm from '@/components/LayoutAdm/HeaderAdm.vue'
import AppHeader from '@/components/Layout/AppHeader.vue'
import Footer from '@/components/Layout/AppFooter.vue'

import { EventBus } from '@/functions/event-bus'
import { setLogoutTimer } from './plugins/auth';

export default {
  name: 'App',
  computed: {
    showLayout() {
      return this.$route.meta.layout === true;
    }
  },
  components: {
    HeaderAdm,
    AppHeader,
    Footer,
    CustomLoading,
    SnackbarGlobal
  },
  created() {

    function parseJwt(token) {
      if (!token) return null;
      try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split('')
            .map(c => `%${('00' + c.charCodeAt(0).toString(16))?.slice(-2)}`)
            .join('')
        );
        return JSON.parse(jsonPayload);
      } catch (e) {
        console.error('Error al decodificar JWT:', e);
        return null;
      }
    }

    const token = localStorage.getItem('token');
    const payload = parseJwt(token);


    if (payload && payload.exp && payload.iat) {
      //const duracionSegundos = payload.exp - payload.iat;
      const tiempoRestanteSegundos = payload.exp - Math.floor(Date.now() / 1000);

      //console.log('🕒 Token válido por (segundos):', duracionSegundos);
      //console.log('⏳ Tiempo restante (segundos):', tiempoRestanteSegundos);

      const minutosRestantes = Math.floor(tiempoRestanteSegundos / 60);
      console.log(`⏰  ${minutosRestantes}`);
    } else {
      //console.warn('⚠️ Token no válido o campos faltantes');
    }

    if (token) {
      setLogoutTimer(token, () => {
        const rutaActual = this.$route.fullPath; // ← guarda ruta actual
        const tipoUsuario = localStorage.getItem('tipoUsuario'); // ← obtener antes de borrarlo

        //localStorage.clear();

        localStorage.removeItem('id')
        localStorage.removeItem('token')
        localStorage.removeItem('nombres')
        localStorage.removeItem('aPaterno')
        localStorage.removeItem('aMaterno')
        localStorage.removeItem('email')
        localStorage.removeItem('codAge')
        localStorage.removeItem('menu')
        localStorage.removeItem('idTarjetaTxt')
        localStorage.removeItem('idTarjeta')
        localStorage.removeItem('NombresApaterno')
        localStorage.removeItem('tipoUsuario')

        // Determina ruta de login según tipoUsuario
        let rutaLogin = '/'; // por defecto

        switch (tipoUsuario) {
          case 'admin':
            rutaLogin = '/login-admin';
            break;
          case 'cliente':
            rutaLogin = '/login-cliente';
            break;
          case 'hospital':
            rutaLogin = '/login-hospital';
            break;
          case 'medico':
            rutaLogin = '/login-medico';
            break;
          case 'agente':
            rutaLogin = '/login-agente';
            break;
          case 'colaborador':
            rutaLogin = '/login-colaborador';
            break;
        }

        this.$router.push({
          path: rutaLogin,
          query: { redirect: rutaActual }
        });
      });
    }
    // Escucha el evento global
    EventBus.$on('toggle-loading', (state) => {
      this.isLoading = state
    })
  },
  data() {
    return {
      WhatsApp: 'https://wa.me/524411234567',
      phoneNumber: '4411234567',
      showScroll: false,
      isLoading: false
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
  mounted() {
    // Escuchar scroll para mostrar el botón de subir
    window.addEventListener('scroll', () => {
      this.showScroll = window.scrollY > 200;
    });
  }
}
</script>